import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import { KnowledgeBaseQaPairStatus } from 'uplisting-frontend/models/ai-knowledge-base-qa-pair';

export class KnowledgeCenterStatusFilter extends MultiSelectListFilter {
  id = FilterId.knowledgeCenterStatus;
  optionsType = FilterOptionsType.list;
  optionsList = Object.values(KnowledgeBaseQaPairStatus);
}
